import * as React from 'react';

import { CiriumWrapper } from './CiriumWrapper';
import { CiriumHeader } from '../header/CiriumHeader';

type Props = {
  brandingImageUrl?: string;
  logout?: () => void;
  appName?: string;
  loading?: boolean;
  children: React.ReactNode;
};

export const CiriumWrapperWithHeader: React.FC<Props> = (props: Props) => (
  <CiriumWrapper
    header={
      <CiriumHeader
        logout={props.logout}
        appName={props.appName}
        brandingImageUrl={props.brandingImageUrl}
      />
    }
    loading={props.loading}
  >
    {props.children}
  </CiriumWrapper>
);